import { MarketboardDict } from '../../contracts/dict/IMarketboard';

export const marketBoardDict: MarketboardDict = {
    onLoadEventErrorTitle: 'Something went wrong',
    onLoadEventErrorText: 'Try refreshing the page.',
    MiddleTermAt: 'at',
    MiddleTermVs: 'vs',
    sgpInfoText: 'Click here to enable',
    sgpButtonText: 'SAME GAME PARLAY',
    refreshButtonText: 'Refresh',
    startsIn: 'Starts In:',
    daysText: 'days',
    dayText: 'day',
    turnOnSgpModeText: 'Turn On Same Game Parlay Mode',
    popularTabName: 'Popular',
    quickSgpTabName: 'Quick SGP',
    oddsTabName: 'Odds',
    statsTabName: 'Stats',
    eventNotAvailable: 'This event is not available. Go back',
    homeText: 'home',
    liveText: 'Live'
};
